import React from "react";
import { Card, Row, Col } from "react-bootstrap";

const AlreadyCompleted = ({title}) => {
  return (
    <div className="content questionsArea mock-already-completed mock-container">
      <Row>
        <Col xs={12}>
          <Card.Header>
            <Row>
              <Col xs={12}>
                <Card.Title tag="h4" className="mock-resource-text" >{title}</Card.Title>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <Row className="testFinish unselectable">
              <div className="col-sm-12">
                <p className="mock-resource-text">
                  <span>
                    Dear user, you've already <strong>FINISHED</strong> this
                    mock. Please attempt some other mock.
                  </span>
                </p>
              </div>
            </Row>
          </Card.Body>
        </Col>
      </Row>
    </div>
  );
};

export default AlreadyCompleted;
